export function setAppCtx(ctx: any) {
  Object.defineProperty(window, 'APP_CONTEXT', {
    configurable: false,
    get() {
      return ctx;
    },
  });
}

export function getAppCtx() {
  return window.APP_CONTEXT;
}
